module.exports = __webpack_public_path__ + "img/calendar_one.23bc4b7d.jpg";